export default "/static/img/layers/srtm30-colored.b4bfadf7d45179122188511677f0acba.png";